<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="form_no">TNA Form Number</label>
                                <input type="text"
                                       v-model="search_data.form_no" id="form_no"
                                       name="form_no"
                                       class="form-control form-control-sm"
                                       placeholder="Search by Form Number"
                                />
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="followup_form_no">Followup Form Number</label>
                                <input type="text"
                                       v-model="search_data.followup_form_no" id="followup_form_no"
                                       name="followup_form_no"
                                       class="form-control form-control-sm"
                                       placeholder="Search by Form Number"
                                />
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="household_number">Household Number</label>
                                <input type="text"
                                       v-model="search_data.household_number" id="household_number"
                                       name="household_number"
                                       class="form-control form-control-sm"
                                       placeholder="Search by HH No"
                                />
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="name">Household Head Name</label>
                                <input
                                        type="text"
                                        v-model="search_data.name" id="name" name="name"
                                        class="form-control form-control-sm"
                                        placeholder="Search by Name"
                                />
                            </div>
                        </div>
                        <div class="form-row mt-1">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="c_village_id">Village</label>
                                <select
                                        v-model="search_data.c_village_id"
                                        id="c_village_id" name="c_village_id"
                                        class="form-control form-control-sm"
                                >
                                    <option selected :value="''">Select a village</option>
                                    <option
                                            v-for="(village, index) in villages"
                                            :key="index"
                                            :value="village.id"
                                    >{{ village.id }} : {{ village.desc }}
                                    </option
                                    >
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="c_mouza_id">Mouza</label>
                                <select
                                        v-model="search_data.c_mouza_id"
                                        class="form-control form-control-sm"
                                        name="c_mouza_id"
                                        id="c_mouza_id"
                                >
                                    <option selected :value="''">Select a Mouza</option>
                                    <option
                                            v-for="(mouza, index) in mouzas"
                                            :key="index"
                                            :value="mouza.id"
                                    >{{ mouza.id }} : {{ mouza.desc }}
                                    </option
                                    >
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="c_training_trade_id">Trade</label>
                                <select v-model="search_data.c_training_trade_id"
                                        id="c_training_trade_id" class="form-control form-control-sm" name="c_training_trade_id">
                                    <option :value="''" selected>Select Training Trade</option>
                                    <option v-for="(trade, index) in trades" :key="index" v-bind:value="trade.id">
                                        {{ trade.id }} : {{ trade.desc }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="batch_no">Batch No</label>
                                <select class="form-control form-control-sm" v-model="search_data.batch_no" id="batch_no" name="batch_no">
                                    <option :value="''" selected>Select Batch no.</option>
                                    <option value="01">01</option>
                                    <option value="02">02</option>
                                    <option value="03">03</option>
                                    <option value="04">04</option>
                                    <option value="05">05</option>
                                    <option value="06">06</option>
                                    <option value="07">07</option>
                                    <option value="08">08</option>
                                    <option value="09">09</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                    <option value="13">13</option>
                                    <option value="14">14</option>
                                    <option value="15">15</option>
                                    <option value="16">16</option>
                                    <option value="17">17</option>
                                    <option value="18">18</option>
                                    <option value="19">19</option>
                                    <option value="20">20</option>
                                    <option value="21">21</option>
                                    <option value="22">22</option>
                                    <option value="23">23</option>
                                    <option value="24">24</option>
                                    <option value="25">25</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-row mt-1">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="followup_status">followup Status</label>
                                <select class="form-control form-control-sm" v-model="search_data.followup_status" id="followup_status" name="followup_status">
                                    <option :value="''" selected>Select followup Type</option>
                                    <option value="1">Followup beginning</option>
                                    <option value="2">Followup after</option>
                                    <option value="99">Both</option>
                                </select>
                            </div>
                        </div>
                        <button
                                @click.prevent="search"
                                class="btn btn-success btn-sm mt-2"
                        >
                            Search
                        </button>
                    </form>
                </b-card>


                <b-card>
                    <div v-if="followups.total > 0" class="row mb-2">
                        <div class="col-sm-12">
                            <span class="badge badge-success mr-2">Total Search Data Found: {{ followups.total }}</span>
                        </div>
                    </div>
                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>SL</th>
                                <th>FollowUp Form No.</th>
                                <th>TNA Form No.</th>
                                <th>Trainee Name</th>
                                <th>Mouza</th>
                                <th>Created Date</th>
                                <th>Followup Type</th>
                                <th>Option</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr  v-for="(followup, index) in followups.data" :key="index">
                                <td>{{ followups.from + index}}</td>
                                <td>{{ followup.followup_form_no }}</td>
                                <td>{{ followup.trainee_form_no }}</td>
                                <td>
                                    <router-link :to="{name: 'traineeView', params: { trainee_id: followup.trainee_id }}"
                                                 tag="a" target="_blank">{{ followup.rep_name ?  followup.rep_name : followup.name }}
                                    </router-link>
                                </td>
                                <td>{{ followup.desc }}</td>
                                <td>{{ customDate(followup.created_at) }}</td>
                                <td>
                                    <span v-if="followup.trade_use != null">Before Training</span>
                                    <span v-else>After Training</span>
                                </td>
                                <td>
                                    <router-link
                                            :to="{name: 'traineeFollowupView',params: { followup_id: followup.id }}"
                                            tag="a"
                                            class="action-icon" target="_blank" title="Trainee Followup View">
                                        <i class="mdi mdi-details editButton"></i>
                                    </router-link>
                                    <router-link
                                            :to="{name: 'followupComparison',params: { trainee_id: followup.trainee_id }}"
                                            tag="a"
                                            class="action-icon" title="Trainee Followup Comparison"
                                            target="_blank">
                                        <i class="mdi mdi-format-list-bulleted addButton"></i>
                                    </router-link>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <h5 v-if="followups.total == 0" class="text-center text-secondary">
                        No Data Found
                    </h5>
                    <div class="float-right">
                        <pagination :data="followups" :limit="2" @pagination-change-page="getResults"></pagination>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";
    import jsPDF from 'jspdf'
    import html2canvas from "html2canvas"
    import moment from "moment";

    export default {
        page: {
            title: "Trainee List",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader},
        data() {
            return {
                title: "Search Trainee",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "Trainee",
                        active: true
                    }
                ],
                followups: {},
                search_data: {
                    form_no: '',
                    household_number: '',
                    name: '',
                    c_village_id: '',
                    c_mouza_id: '',
                    c_training_trade_id: '',
                    batch_no: '',
                    followup_status: '',
                },
                villages: [],
                trades: [],
                mouzas: [],
                trainee: {},
                flag: false,
            };
        },


        mounted() {
            this.getCodes();
        },
        methods: {
            customDate(date) {
                return moment.utc(date).local().format("L LT");
            },
            getCodes() {
                http.get("api/ses/codes").then(response => {
                    if (!response.error) {
                        let data = response.data;
                        this.villages = data.villages;
                        this.mouzas = data.mouzas;
                        this.trades = data.trades;
                    }
                });
            },
            search() {
                http.post("api/followup/search/list", this.search_data).then(response => {
                    if (!response.error) {
                        this.flag = true;
                        this.followups = response.data.followups;
                    }
                });
            },
            getResults(page = 1) {
                http.post('api/followup/search/list?page=' + page, this.search_data)
                    .then(response => {
                        this.flag = true;
                        this.followups = response.data.followups;
                    });
            },
        },
        computed: {
            userPermission() {
                return this.$store.state.user
            }
        },
        created() {
            this.$store.dispatch('getUserPermission')
        },
    };
</script>
